import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  container: {
    "@media (max-width:899.95px)": { width: "100%" },
    // height: "calc(var(--app-vh) - 462px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  containerSearch: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
    gap: "15px",
    width: "33%",
    "& > div": {
      width: "100%",
      margin: 0,
    },
  },
  // Mirrors StepAssignmentOfTheCollaborator: navigation buttons sit on one
  // row, spread apart, so "Previous" and "Skip" read as peers of the primary
  // action rather than as an afterthought beneath it.
  containerButton: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "15px",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
});

export default useStyles;
